class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      {once: true}
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (parsedState.sections) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section) => {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      });

      if (this.header) this.header.reveal();
      this.open();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const dom = new DOMParser().parseFromString(html, 'text/html');
    const target = dom.querySelector(selector);
    // Default SSR render
    if (target) {
      return target.innerHTML;
      // Bugfix for mismatched key items with price script
    } else {
      if (!this.responseData) return '';
      const container = document.createElement('div');
      const imageContainer = document.createElement('div');
      imageContainer.classList.add('cart-notification-product__image', 'global-media-settings');
      const image = document.createElement('img');
      image.setAttribute('loading', 'lazy');
      image.setAttribute('width', 84);
      image.setAttribute('height', 84);
      image.setAttribute('src', this.responseData.image);
      image.setAttribute('alt', this.responseData.title);
      imageContainer.appendChild(image);
      container.appendChild(imageContainer);
      const contentContainer = document.createElement('div');
      const sku = document.createElement('div');
      sku.classList.add('cart-notification-product__sku');
      sku.textContent = this.responseData.sku;
      contentContainer.appendChild(sku);
      const productName = document.createElement('h3');
      productName.classList.add('cart-notification-product__name');
      productName.textContent = this.responseData.title;
      contentContainer.appendChild(productName);
      const productPrice = document.createElement('div');
      productPrice.classList.add('cart-notification-product__price');
      let price = this.responseData.price;
      price = price / 100;
      price = price.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
      productPrice.textContent = price;
      contentContainer.appendChild(productPrice);
      container.appendChild(contentContainer);
      return container.innerHTML;
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
